var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal-component',{attrs:{"options":_vm.optionsHandled,"value":_vm.show},on:{"cancel":_vm.close}},[_c('div',{staticClass:"container"},[_c('span',[_vm._v(" "+_vm._s(_vm.observation || 'Nada informado')+" ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }